


























import { AddressBridge, CurrentLocationText } from '@/views/address/bridge'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'
import { navigateTo } from '@/router'

export default defineClassComponent(
  {
    components: {
      CurrentLocationText,
    },
  },
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 点击规格
      handleSpecClick = () => {
        this.goodsData.value.showSkuPicker({
          action: 'buy',
        })
      }

      // 点击送至
      handleSendClick = () => {
        AddressBridge.chooseAddress()
      }

      // 点击资质
      handleCertClick = () => {
        navigateTo('MartCert', {
          id: this.goodsData.value.merchantId,
        })
      }
    },
)
